export const mutations = {
  resetState(state) {
    //state.loading = 0
    state.rightDrawer = false;
    state.breadcrumbs = [];
    state.history = [];
    state.itemsPerPage = 10;
    state.itemsPerPageOptions = [5, 10, 25, 50, 100, -1];
    state.features = [];
  },
  setLoading(state, arg) {
    if (arg) {
      state.loading++;
    } else if (state.loading > 0) {
      state.loading--;
    }
  },
  setBreadcrumbs(state, array) {
    state.breadcrumbs = array;
  },
  addHistory(state, arg) {
    const fifo = state.history.filter(
      (entry) => JSON.stringify(entry.to) !== JSON.stringify(arg.to)
    );
    if (fifo.length > 9) {
      fifo.pop();
    }
    fifo.unshift(arg);
    state.history = fifo;
  },
  clearHistory(state) {
    state.history = [];
  },
  setRightDrawer(state, visible) {
    state.rightDrawer = visible;
  },
  setFeatures(state, list) {
    state.features = [...list];
  },
  setAssetsTenant(state, tenant) {
    state.assets = tenant;
  },
  reload(state, data) {
    // Dummy mutation. An event handler in the related view will act on this mutation type.
  },
};
